var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserSessionPink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M2.66699 11.9993L4.00033 10.666H13.3337V2.66602H2.66699V11.9993ZM10.0003 5.99935H11.3337V7.33268H10.0003V5.99935ZM7.33366 5.99935H8.66699V7.33268H7.33366V5.99935ZM4.66699 5.99935H6.00033V7.33268H4.66699V5.99935Z",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 1.33398H2.66634C1.93301 1.33398 1.33301 1.93398 1.33301 2.66732V14.6673L3.99967 12.0007H13.333C14.0663 12.0007 14.6663 11.4007 14.6663 10.6673V2.66732C14.6663 1.93398 14.0663 1.33398 13.333 1.33398ZM13.333 10.6673H3.99967L2.66634 12.0007V2.66732H13.333V10.6673ZM4.66634 6.00065H5.99967V7.33398H4.66634V6.00065ZM7.33301 6.00065H8.66634V7.33398H7.33301V6.00065ZM9.99967 6.00065H11.333V7.33398H9.99967V6.00065Z",
    fill: "#E56800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSessionPink);
export default __webpack_public_path__ + "static/media/UserSessionPink.1635ec1e87cdbb6b10d31b41e680ab4c.svg";
export { ForwardRef as ReactComponent };